import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Technology } from '../model/technology';
import { TechnologySerializer } from '../model/serializer/technology-serializer';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class TechnologyService extends ApiService<Technology> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'technology',
      new TechnologySerializer());
  }
}
